/**
 * Created by Alex Xia on 04/15/2020.
 * Description:
 *
 * ------ maintenance history ------
 */
import { Subject } from 'rxjs';

export enum CalendarViewLayoutMode {
    Calendar = 1,
    Grid = 2
}

export class CalendareViewLayoutInfo {
    layoutMode: CalendarViewLayoutMode;

    constructor() {
        this.layoutMode = CalendarViewLayoutMode.Calendar;
    }
}

export class CalendarViewLayoutMenuConfig {
    layoutInfo: CalendareViewLayoutInfo;
    actions$: Subject<any>;
    events$: Subject<any>;

    constructor() {
        this.layoutInfo = new CalendareViewLayoutInfo();
        this.actions$ = new Subject();
        this.events$ = new Subject();
    }
}




